const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.campo = model;
  },

  setModels(state, models) {
    state.campos = models;
  },

  addModel(state, model) {
    state.campos.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.campos
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.campos.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
